import React from 'react';

export const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-b from-primary-50 to-white flex flex-col items-center justify-center">
      <div className="text-center">
        {/* Logo with pulse animation */}
        <div className="w-32 h-32 mx-auto mb-8 animate-pulse">
          {/* If you have an SVG logo, you can include it directly */}
          <img 
            src="/logo.svg" 
            alt="Warka Logo" 
            className="w-full h-full object-contain"
            onError={(e) => {
              // Fallback if logo doesn't load
              e.currentTarget.style.display = 'none';
              document.getElementById('logoText')!.style.display = 'block';
            }}
          />
          <div id="logoText" className="text-3xl font-bold text-primary-600 hidden">
            Warka
          </div>
        </div>
        
        {/* Loading indicator */}
        <div className="flex space-x-2 justify-center">
          <div className="w-2 h-2 rounded-full bg-primary-600 animate-[bounce_1s_infinite_0ms]"></div>
          <div className="w-2 h-2 rounded-full bg-primary-600 animate-[bounce_1s_infinite_200ms]"></div>
          <div className="w-2 h-2 rounded-full bg-primary-600 animate-[bounce_1s_infinite_400ms]"></div>
        </div>
        
        {/* Loading message */}
        <p className="mt-4 text-gray-600">Loading...</p>
      </div>
    </div>
  );
};